

const DataTransmissionLegend = ({min}) => {
    const circleGreen = () => {
        return (
            <span className="circle-div-wrapper">
                <div className="circle-green"/>
            </span>
        )
    }
    const circleYellow = () => {
        return (
            <span className="circle-div-wrapper">
                <div className="circle-yellow"/>
            </span>
        )
    }
    const circleRed = () => {
        return (
            <span className="circle-div-wrapper">
                <div className="circle-red"/>
            </span>
        )
    }

    return (
        <div className="data-transmission-legend-container">
            <h4>Legend</h4>
            <div className="data-transsmision-legend-row">
                {circleGreen()}
                <span> &lt; {min} min</span>
            </div>
            <div className="data-transsmision-legend-row">
                {circleYellow()}
                <span> {min} min to {2*min} min</span>
            </div>
            <div className="data-transsmision-legend-row">
                {circleRed()}
                <span> &gt; {2*min} min</span>
            </div>
        </div>
    )
}

export default DataTransmissionLegend;